var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"file",staticClass:"input-file",attrs:{"type":"file","id":"file","required":""},on:{"change":function($event){return _vm.handleFileUpload()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }